<template>
  <div v-if="slides.length > 0" class="app-screens">
    <h2 class="app-screens__title">
      {{ appScreensTitle }}
    </h2>
    <slider
      :slides="slides"
      :current-index="currentIndex"
      @onUserAction="onUserAction"
    >
      <template #left-area>
        <PhoneContentTransitionGroup
          :slides="slides"
          :current-index="currentIndex"
        />
      </template>
      <template #right-area>
        <TextContentTransitionGroup
          :slides="slides"
          :current-index="currentIndex"
        />
      </template>
    </slider>
  </div>
</template>

<script>
import { sliderActionTypes } from '@/modules/appScreens/actionTypes'
import PhoneContentTransitionGroup from '@/modules/appScreens/components/PhoneContentTransitionGroup'
import TextContentTransitionGroup from '@/modules/appScreens/components/TextContentTransitionGroup'

import Slider from './components/Slider'

export default {
  name: 'DotcomAppScreens',
  components: {
    TextContentTransitionGroup,
    PhoneContentTransitionGroup,
    Slider,
  },
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    currentActiveSlide: {
      type: String,
      default: '0',
    },
    appScreensTitle: {
      type: String,
      default: '',
    },
    videoFallbackText: {
      type: String,
      default: null,
    },
    playBackRate: {
      type: String,
      default: '4000',
    },
    slidesData: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    currentIndex: 0,
    slideIncrement: 1,
    slides: [],
    timer: {},
  }),
  computed: {
    slidesCount() {
      return this.slides.length
    },
  },
  mounted: function () {
    try {
      this.slides = JSON.parse(this.slidesData)
    } catch (e) {
      console.error('Slides data parse error ', e)
    } finally {
      this.currentIndex = parseInt(this.currentActiveSlide)
      if (this.autoplay) {
        this.loop()
      }
    }
  },
  methods: {
    onUserAction(actionType) {
      this.stopLoop()
      switch (actionType.type) {
        case sliderActionTypes.NEXT:
          this.next()
          break
        case sliderActionTypes.PREVIOUS:
          this.previous()
          break
        case sliderActionTypes.DOT:
          this.dotClick(actionType)
          break
        default:
          break
      }
    },
    loop() {
      this.timer = setInterval(this.next, parseInt(this.playBackRate))
    },
    stopLoop() {
      clearInterval(this.timer)
    },
    next() {
      this.currentIndex =
        this.currentIndex + this.slideIncrement < this.slidesCount
          ? (this.currentIndex += this.slideIncrement)
          : 0
    },
    previous() {
      this.currentIndex =
        this.currentIndex - this.slideIncrement >= 0
          ? (this.currentIndex -= this.slideIncrement)
          : this.slidesCount - this.slideIncrement
    },
    dotClick({ slideIndex }) {
      this.currentIndex = slideIndex
    },
  },
}
</script>

<style lang="postcss">
.app-screens {
  .app-screens__title {
    font-weight: 700;
    font-size: 30px;
    margin-bottom: var(--spacing-8);
  }
}
</style>
